export default __webpack_public_path__ + "0c29cd559b7def7256ab59556048928f.svg";